module.exports = __webpack_public_path__ + "media/proksee-viewer/images/icon-up-c98d3844dfa5e49bb41671091c6e5432.png";